import { GameType } from '@modules/games/Game/constants/availableGames';
import { ResultFunction } from '@legacyApp/client/components/provablyFair/verification/ResultFunction.type';
import {
	diceVerification,
	gameVerification,
	hiloFullTailVerification,
} from '@legacyApp/client/modules/app/verificationServcie';

export const getResultFunction = (game: GameType): ResultFunction => {
	// TODO: NEW GAME FLAG
	switch (game) {
		case GameType.DICE: {
			return diceVerification;
		}

		case GameType.HILO: {
			return (client_seed, server_seed, nonce) => {
				hiloFullTailVerification(client_seed, server_seed, nonce);

				return gameVerification(client_seed, server_seed, nonce, 52, 100);
			};
		}

		case GameType.LIMBO: {
			return (client_seed, server_seed, nonce) => {
				return gameVerification(client_seed, server_seed, nonce, 100000000);
			};
		}

		case GameType.PLINKO: {
			return (client_seed, server_seed, nonce) => {
				return gameVerification(client_seed, server_seed, nonce, 2, 16);
			};
		}

		case GameType.KENO: {
			return (client_seed, server_seed, nonce) => {
				return gameVerification(
					client_seed,
					server_seed,
					nonce,
					(nonce: number) => {
						return 40 - nonce;
					},
					10,
				);
			};
		}

		default: {
			throw new Error('Game not found get result function');
		}
	}
};
